/*
  FMH 25.09 — photo viewer for the product gallery (replaces Dawn's full-page zoom modal).
  Click on a gallery photo → dark overlay, the photo fits the screen, swipe / arrows / ← → keys
  to go through the gallery, counter "3 / 7", close with ×, Esc or a click on the dark area.
  Only the photos rendered in the gallery are included, so other colours' masters stay out.
*/
(function () {
  if (window.fmhLightboxReady) return;
  window.fmhLightboxReady = true;

  var box, track, counter, prevBtn, nextBtn, closeBtn, slides = [], index = 0, lastFocus = null, scrollTimer;

  function bestSrc(img) {
    if (!img) return '';
    var srcset = img.getAttribute('srcset') || '';
    // smallest candidate that is still sharp on this screen (full-size PNGs are heavy on phones)
    var need = Math.min(2000, Math.max(window.innerWidth, window.innerHeight) * (window.devicePixelRatio || 1));
    var list = srcset.split(',').map(function (part) {
      var bits = part.trim().split(/\s+/);
      return { url: bits[0], w: parseInt(bits[1], 10) || 0 };
    }).filter(function (c) { return c.url && c.w; }).sort(function (a, b) { return a.w - b.w; });
    for (var i = 0; i < list.length; i++) if (list[i].w >= need) return list[i].url;
    return list.length ? list[list.length - 1].url : (img.currentSrc || img.src);
  }

  function build() {
    box = document.createElement('div');
    box.className = 'fmh-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product photos');
    box.hidden = true;
    box.innerHTML =
      '<div class="fmh-lb__counter" aria-live="polite"></div>' +
      '<button type="button" class="fmh-lb__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="fmh-lb__nav fmh-lb__nav--prev" aria-label="Previous photo">&#8249;</button>' +
      '<div class="fmh-lb__track"></div>' +
      '<button type="button" class="fmh-lb__nav fmh-lb__nav--next" aria-label="Next photo">&#8250;</button>';
    document.body.appendChild(box);
    track = box.querySelector('.fmh-lb__track');
    counter = box.querySelector('.fmh-lb__counter');
    prevBtn = box.querySelector('.fmh-lb__nav--prev');
    nextBtn = box.querySelector('.fmh-lb__nav--next');
    closeBtn = box.querySelector('.fmh-lb__close');

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(index - 1); });
    nextBtn.addEventListener('click', function () { go(index + 1); });
    track.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG') close();
    });
    track.addEventListener('scroll', function () {
      loadAround(Math.round(track.scrollLeft / track.clientWidth));
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) { index = i; update(); }
      }, 60);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      else if (e.key === 'Tab') {
        var f = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.disabled; });
        var at = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(at + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
      }
    });
    window.addEventListener('resize', function () {
      if (!box.hidden) track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
    });
  }

  function update() {
    counter.textContent = (index + 1) + ' / ' + slides.length;
    prevBtn.disabled = index <= 0;
    nextBtn.disabled = index >= slides.length - 1;
    var single = slides.length < 2;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
    loadAround(index);
  }

  // load the current photo and two on each side, so swiping never shows an empty frame
  function loadAround(at) {
    for (var i = at - 2; i <= at + 2; i++) {
      var img = slides[i] && slides[i].querySelector('img[data-src]');
      if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    }
  }

  function go(i) {
    if (i < 0 || i >= slides.length) return;
    index = i;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    update();
  }

  function open(gallery, startItem) {
    if (!box) build();
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-list > li'))
      .filter(function (li) { return li.querySelector('.product__media img'); });
    track.innerHTML = '';
    slides = items.map(function (li) {
      var img = li.querySelector('.product__media img');
      var s = document.createElement('div');
      s.className = 'fmh-lb__slide';
      var big = document.createElement('img');
      big.setAttribute('data-src', bestSrc(img));
      big.alt = img.alt || '';
      big.draggable = false;
      s.appendChild(big);
      track.appendChild(s);
      return s;
    });
    index = Math.max(0, items.indexOf(startItem));
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('fmh-lb-open');
    track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
    update();
    closeBtn.focus({ preventScroll: true });
  }

  function close() {
    box.hidden = true;
    document.documentElement.classList.remove('fmh-lb-open');
    track.innerHTML = '';
    slides = [];
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // Capture phase: runs before Dawn's modal-opener, so the old full-page modal never opens.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('media-gallery .product__media-toggle');
    if (!toggle) return;
    var gallery = toggle.closest('media-gallery');
    var item = toggle.closest('.product__media-list > li');
    if (!item || !item.querySelector('.product__media img')) return; // 3D models etc. keep stock behaviour
    e.preventDefault();
    e.stopImmediatePropagation();
    open(gallery, item);
  }, true);
})();
